import React from 'react'
import { inject, observer } from 'mobx-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Navbar = inject('userStore', 'uiStore')((props) => {
  const { userStore } = props
  const logout = (event) => userStore.logout(event)
  return (
    <nav className='navbar is-white app-navbar'>
      <NavbarButton />
      <div className='navbar-brand'>
        <a href='' className='navbar-item'>
          Letnis Produtos
        </a>
      </div>
      <div id='navbar-menu' className='navbar-menu'>
        <div className='navbar-end'>
          <div className='navbar-item has-dropdown is-hoverable'>
            <a className='navbar-link'>
              Configurações
            </a>
            <div className='navbar-dropdown'>
              <a className='navbar-item' onClick={logout}>
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
})

const NavbarButton = inject('uiStore')(observer(props => {
  const { uiStore } = props
  const { isOpen } = uiStore.state.sidebar
  return (
    <div className="navbar-item">
      <button className='button is-info' onClick={() => uiStore.setIsOpen(!isOpen)}>
        <FontAwesomeIcon icon='bars' />
      </button>
    </div>
  )
}))

export default Navbar



// WEBPACK FOOTER //
// ./src/components/dashboard/Navbar.js